import { type ApiClientResponse, apiClient, routes } from 'common/services';

export const markAsRead = async ({ id }: { id: string }) =>
  apiClient.post<unknown, ApiClientResponse<unknown>>(routes.posts.markAsRead(id));
